import { useState, useEffect, useCallback } from 'react';
import { safeErrorMessage } from '../../utils/apiError';

// GET `url` with the session token and track {data, loading, error}. Pass
// url = null to skip the request (e.g. a tab that isn't open yet, or a
// module the school has switched off). `reload()` fetches the same url
// again, e.g. after a save.
export default function useApi(token, url) {
  const [state, setState] = useState({ data: null, loading: Boolean(url), error: '' });
  const [reloadCount, setReloadCount] = useState(0);
  const reload = useCallback(() => setReloadCount((count) => count + 1), []);

  useEffect(() => {
    if (!url) {
      setState({ data: null, loading: false, error: '' });
      return undefined;
    }
    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true, error: '' }));
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(async (response) => {
        if (cancelled) return;
        if (response.ok) {
          setState({ data: await response.json(), loading: false, error: '' });
        } else {
          setState({ data: null, loading: false, error: await safeErrorMessage(response, 'Failed to load') });
        }
      })
      .catch(() => {
        if (!cancelled) setState({ data: null, loading: false, error: 'Network error. Please check your connection and try again.' });
      });
    return () => { cancelled = true; };
  }, [token, url, reloadCount]);

  return { ...state, reload };
}
